import { render, staticRenderFns } from "./SmsBroadcastPreview.vue?vue&type=template&id=66530a27&scoped=true"
import script from "./SmsBroadcastPreview.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastPreview.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastPreview.vue?vue&type=style&index=0&id=66530a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66530a27",
  null
  
)

export default component.exports